/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SlowIlsInfo } from '../../models/slow-ils-info';

export interface IlsControllerGetAllSlowIlsInfos$Params {
  getDataSize: boolean;
}

export function ilsControllerGetAllSlowIlsInfos(http: HttpClient, rootUrl: string, params: IlsControllerGetAllSlowIlsInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SlowIlsInfo>>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerGetAllSlowIlsInfos.PATH, 'get');
  if (params) {
    rb.path('getDataSize', params.getDataSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SlowIlsInfo>>;
    })
  );
}

ilsControllerGetAllSlowIlsInfos.PATH = '/ils/listAllSlow/{getDataSize}';
